module.exports = __webpack_public_path__ + "static/media/Albus Dumbledore 3.2efb2645.jpg";